(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

import React, { createRef } from 'react';
import PropTypes from 'prop-types';
import uuid from 'uuid/v4';
import { HtmlElement } from "../base";
import Button from "./Button.js";

var UploadButton = function UploadButton(props) {
  var children = props.children,
      accept = props.accept,
      onChange = props.onChange,
      multiple = props.multiple,
      reset = props.reset,
      testSelector = props.testSelector,
      rest = _objectWithoutProperties(props, ["children", "accept", "onChange", "multiple", "reset", "testSelector"]);

  var dataTestSelector = testSelector ? {
    'data-test-selector': testSelector
  } : {};
  var id = uuid();

  var handleChange = function handleChange(e) {
    onChange(e);

    if (reset) {
      e.target.value = null;
    }
  };

  var fileInputRef = createRef();

  var handleKeyEvent = function handleKeyEvent(e) {
    if (e.which === 32 || e.which === 13) {
      e.preventDefault();
      fileInputRef.current.click();
    }
  };

  var handleClick = function handleClick() {
    fileInputRef.current.click();
  };

  return React.createElement(Button, _extends({}, rest, {
    onClick: handleClick
  }), React.createElement("span", _extends({}, dataTestSelector, {
    role: "button",
    tabIndex: "0",
    "aria-controls": id,
    onKeyUp: handleKeyEvent,
    onKeyPress: handleKeyEvent
  }), children), React.createElement(HtmlElement, {
    as: "input",
    id: id,
    style: {
      display: 'none'
    },
    type: "file",
    multiple: multiple,
    onChange: handleChange,
    ref: fileInputRef,
    accept: accept
  }));
};

UploadButton.propTypes = {
  multiple: PropTypes.bool,

  /**
   * Whether the field should be reset after file is selected
   */
  reset: PropTypes.bool,

  /**
   * Which file types to accept. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/file#attr-accept) for more.
   */
  accept: PropTypes.string
};
UploadButton.defaultProps = {
  multiple: false,
  reset: false,
  accept: ''
};
var _default = UploadButton;
export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(UploadButton, "UploadButton", "/home/vsts/work/1/s/src/components/buttons/UploadButton.js");
  reactHotLoader.register(_default, "default", "/home/vsts/work/1/s/src/components/buttons/UploadButton.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();